import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Tour from 'reactour'
import {Button} from "antd";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
// import TourPrevIcon from "../../assets/icons/tour-prev-icon.svg";
// import {usersSteps} from "./TourUtils";
import TourStepContentSmall from './TourStepContentSmall'
import { editTourUsers } from '../../actions/TourAction'
class BunkeyUsersTour extends Component {
  _isMounted = false;
  constructor(props) {
    super(props)

    this.state = {
      steps: [],
      isTourOpen: false
    }
    this.current = -1
  }

  disableBody = target => disableBodyScroll(target)
  enableBody = target => enableBodyScroll(target)

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidMount(){
    const { tourUsers, intl } = this.props
    var stepsValuesTourUsers = []
    if (tourUsers && tourUsers.length !== 0) {
      tourUsers.forEach((r) => {
        r.content = <TourStepContentSmall
          title = {intl.formatMessage({id: 'users_' + r.title})}
          subtitle = {intl.formatMessage({id: 'users_' + r.description})}
        />
        stepsValuesTourUsers.push({...r})
      })
    }
    // const seen = localStorage.getItem(`users_tour_${user._id}`) || false;
    const seen = stepsValuesTourUsers.length === 0;
    if(seen) return;
    this.setState({ 
      isTourOpen: true,
      steps: stepsValuesTourUsers,
    });
  }

  handleSeenSteps = () => {
    const { user, tourUsers } = this.props
    const stepsView = []
    if (tourUsers && tourUsers.length) {
      for (let i = 0; i < this.current; i++) {
        stepsView.push(tourUsers[i].number)
      }
    }
    this.props.editTourUsers(user._id, stepsView)
    // localStorage.setItem(`users_tour_${user._id}`, true)
    this.setState({ isTourOpen: false })
  }

  handleBadgeContent = (current, total) => {
    const { intl } = this.props
    this.current = current
    return `${current} ${intl.formatMessage({ id: 'of' })} ${total}`
  }

  render() {
    const { steps } = this.state
    const { onChangePage, onRequestClose } = this.props
    const savedColor = localStorage.getItem('primaryColor');
    const MenuIcon = (props) =>(
      <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5607 0.439332C12.1464 1.02511 12.1464 1.97484 11.5607 2.56062L3.62127 10.5L11.5607 18.4394C12.1464 19.0252 12.1464 19.9749 11.5607 20.5607C10.9749 21.1464 10.0252 21.1464 9.43938 20.5607L0.439333 11.5606C-0.146444 10.9749 -0.146444 10.0251 0.439333 9.43936L9.43938 0.439332C10.0252 -0.146444 10.9749 -0.146444 11.5607 0.439332Z" fill={props.fill}/>
      </svg>
    )
    return (
      <React.Fragment>
        {steps && steps.length > 0 && <Tour
          accentColor={savedColor}
          badgeContent={this.handleBadgeContent}
          getCurrentStep={(curr) => {
            // if(curr > 0){
              onChangePage(curr)
            // }
          }}
          steps={steps}
          rounded={5}
          onAfterOpen={this.disableBody}
          isOpen={this.state.isTourOpen}
          maskSpace={20}
          lastStepNextButton={<Button
            size={'large'}
            type={'primary'}
            block
          >
            Entendido
          </Button>}
          onRequestClose={()=>{
            onRequestClose();
            this.handleSeenSteps();
          }}
          showNavigation={true}
          prevButton={
            <MenuIcon fill={savedColor} />
          }
          nextButton={<Button
            size={'large'}
            type={'primary'}
            block
          >
            Siguiente
          </Button>}
        />}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    token: state.authUser.token,
    tourUsers: state.tours.tourUsers,
  }
}

const mapDispatchToProps = {
  editTourUsers
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(BunkeyUsersTour)))
